import { SelectionRepository as BaseSelectionRepository } from 'shared/projects/SelectionRepository';
import { Selection, SelectionV1 } from 'src/projects/types/Selection';
import { convertSelection } from 'src/projects/convertSelection.ts';

/**
 * SAS binding of the shared selection logic: fixes the selection/view types and wires in the
 * app-specific `convertSelection` (which folds transient location state into the record).
 */
export class SelectionRepository extends BaseSelectionRepository<Selection, SelectionV1> {
    public constructor(selections: Selection[]) {
        super(selections, convertSelection);
    }
}
